/*
 * Copyright (c) 2026.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */

/**
 * Auteur: Jelmer Jellema - Spin in het Web B.V
 * Gegenereerd met Claude Code (AI), 19-08-2026
 *
 * Het lampje rechtsonder dat toont of er verbinding met het backend is (golf 3e). Vervangt
 * `#connectionstatuscontainer`/`#connectionstatus` in canvas.html en leest de
 * `verbonden`-spiegel uit de `SamenwerkingService`.
 */
import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {BaseIslandComponent} from '../base-island.component';
import {SamenwerkingService} from '../../services/samenwerking.service';

@Component({
    selector: 'dl-verbindingsstatus',
    standalone: true,
    templateUrl: './dl-verbindingsstatus.component.html',
    styleUrls: ['./dl-verbindingsstatus.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateModule]
})
export class DlVerbindingsstatusComponent extends BaseIslandComponent {

    /**
     * De bron van de verbindingsstatus.
     */
    protected readonly samenwerking = inject(SamenwerkingService);

    constructor() { super(); }
}
